function routeClass($rootScope, gtmService): Object {
    return {
        restrict: "A",
        scope: {},
        link: (scope, elem, attr, ctrl) => {
            $rootScope.$on("$stateChangeSuccess", (event, toState, toParams, fromState, fromParams) => {
                // don't do anything if they are the same
                if (fromState.name !== toState.name) {
                    elem.removeClass(fromState.name.replace(/\./g, "-"));
                    elem.addClass(toState.name.replace(/\./g, "-"));
                }
                gtmService.sendPageView({name: toState.name, path: toState.url});
            });
        }
    };
}

routeClass.$inject = ["$rootScope", "gtmService"];

angular
    .module("thor.core.routeClass.directive", [])
    .directive("routeClass", routeClass);
